import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import { getMessage } from "CONFIG/i18n";

// Selectors
import { getContractInfo, getIsContractInfoModalOpened, } from "@/Redux/Selector/SessionSelector"
import modalScrollBar from "@/Components/ModalScrollBar/ModalScrollBar";

// Action
import { sessionActions }  from "@/Config/ActionFactory"

// Icon
import ic_close_waiting_room from "@/Assets/Images/ic_close_waiting_room.svg"

/**
 * Contract Info Modal
 */
class ContractInfoModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contractInfo: props.contractInfo, // fixed
      isContractInfoModalOpened: props.isContractInfoModalOpened, // true <-> false
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isContractInfoModalOpened !== prevProps.isContractInfoModalOpened) {
      this.setState({
        isContractInfoModalOpened: this.props.isContractInfoModalOpened
      });
    }
  }

  toggle = () => {
    sessionActions.setIsContractInfoModalOpened(!this.state.isContractInfoModalOpened);
  }

  render() {
    return (
      <Modal
        isOpen={this.state.isContractInfoModalOpened}
        toggle={this.toggle}
        backdrop={true}
      >
        <ModalBody>
          <div
            style={{
              display: 'grid',
              gridTemplateRows: 'auto auto',
              gridGap: '1.0REM'
            }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr auto'
              }}
            >
              <div>
                {getMessage("CONTRACT_INFO_MODAL_LABEL")}
              </div>
              <div>
                <img
                  src={ic_close_waiting_room}
                  alt={''}
                  style={{cursor: 'pointer'}}
                  onClick={this.toggle}
                  onKeyDown={() => {}}
                />
              </div>
            </div>
            <ul>
              {
                this.state.contractInfo.map((item) => {
                  return (
                    <li key={item.url}>
                      <a
                        href={item.url}
                        target={'_blank'}
                      >
                        {item.label}
                      </a>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    contractInfo: getContractInfo(state),
    isContractInfoModalOpened: getIsContractInfoModalOpened(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {},
    dispatch
  );
};

export default modalScrollBar(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractInfoModal)));
